<template>
  <div class="sph-survey">
    <div class="sph-survey-header">

      <div class="sph-survey-header-content">
        <h2>
          看诊人工咨询通道
        </h2>
        <h3>
          请完善个人信息，我们会在工作日2小时内回电，工作时间为周一-周五09:00-17:30，非工作时间则顺延至下个工作日。
        </h3>
      </div>
      <img
        src="@/assets/images/sph/top_bg.png"
        alt=""
      />
    </div>
    <div class="sph-survey-form">
      <div class="survey-form-question survey-form-question-border">
        <div class="survey-question-name">
          姓名<span class="survey-question-name-require">*</span>
        </div>
        <div class="survey-question-content">
          <van-field
            v-model="form.user_name"
            placeholder="请输入姓名"
          />
        </div>

      </div>
      <div class="survey-form-question survey-form-question-border">
        <div class="survey-question-name">
          与患者关系<span class="survey-question-name-require">*</span>
        </div>
        <div class="survey-question-content">
          <el-radio-group
            v-model="form.relation"
            :fill="'#002D5D'"
          >
            <el-radio label="本人">本人</el-radio>
            <el-radio label="亲属">亲属</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="survey-form-question survey-form-question-border">
        <div class="survey-question-name">
          手机号<span class="survey-question-name-require">*</span>
        </div>
        <div class="survey-question-content">
          <van-field
            v-model="form.phone"
            placeholder="请输入手机号"
          />
        </div>
      </div>
      <div class="survey-form-question survey-form-question-border">
        <div class="survey-question-name">
          验证码<span class="survey-question-name-require">*</span>
        </div>
        <div class="survey-question-content">
          <van-field
            v-model="form.code"
            center
            clearable
            maxlength="5"
            placeholder="请输入验证码"
          >
            <template #button>
              <el-button
                class="survey-question-code-btn"
                size="small"
                type="info"
                round
                @click="getPhoneCode"
              >{{ countDown ? `${countDown}秒后重新发送` : '获取验证码' }}</el-button>
            </template>
          </van-field>
        </div>
      </div>

      <!-- <div class="survey-form-question">
        <div class="survey-question-name">
          病种<span class="survey-question-name-require">*</span>
        </div>
        <div class="survey-question-content">
          <el-radio-group v-model="form.bingzhong">
            <el-radio label="胃癌"></el-radio>
            <el-radio label="肠癌"></el-radio>
            <el-radio label="肺癌"></el-radio>
            <el-radio label="肝癌"></el-radio>
            <el-radio label="乳腺癌"></el-radio>
            <el-radio label="卵巢癌"></el-radio>
            <el-radio label="宫颈癌"></el-radio>
            <el-radio label="血液肿瘤"></el-radio>
            <el-radio label="其他"></el-radio>
          </el-radio-group>
          <el-input
            v-if="form.bingzhong === '其他'"
            v-model="form.other"
            placeholder="请输入其他病种"
          ></el-input>
        </div>
      </div> -->

      <div class="survey-form-question">
        <div class="survey-question-name">
          病情描述<span class="survey-question-name-require">*</span>
        </div>
        <div class="survey-question-content">
          <el-input
            v-model="form.bingqingmiaoshu"
            placeholder="疾病名称、确诊医院、确诊时间及目前治疗情况"
            type="textarea"
            :rows="2"
          ></el-input>
        </div>
      </div>

      <!-- <div class="survey-form-question survey-form-question-border">
        <div class="survey-question-name">
          邮箱
        </div>
        <div class="survey-question-content">
          <van-field
            v-model="form.email"
            placeholder="请输入邮箱"
          />
        </div>
      </div> -->

      <div
        class="survey-form-protocol"
        @click="throttledProtocolClick"
      >
        <el-radio
          :value="ifAgree"
          :label="1"
        >&nbsp;</el-radio>
        <span class="survey-form-protocol-lable">
          已阅读并同意<span
            class="color-red"
            @click="protocolShow = true"
          >《用户隐私协议》</span>
        </span>

      </div>

      <div class="survey-form-btn">
        <el-button
          type="primary"
          round
          :loading="loading"
          @click="throttledSubmit"
        >确认</el-button>
      </div>

    </div>
    <van-popup v-model="protocolShow">
      <protocol />
    </van-popup>

  </div>
</template>

<script>
import protocol from "./components/protocol";
import sphService from "@/apis/sph/index.js";
import { Message } from "element-ui";
// import wx from "wx";
import wechatService from "@/apis/weChat/index.js";
import { throttle } from "@/utils/utils";

let timer = null;
// const mailReg =
//   /^[a-z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
const phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
export default {
  data() {
    return {
      form: {
        user_name: "",
        bingqingmiaoshu: "",
        other: "",
        location_x: 0,
        location_y: 0,
      },
      protocolShow: false,
      countDown: 0,
      ifAgree: false,
      loading: false,
    };
  },
  components: {
    protocol,
  },
  created() {
    this.getLocation();
    this.throttledSubmit = throttle(this.submit, 2000);
    this.throttledProtocolClick = throttle(this.protocolClick, 500);
  },
  methods: {
    getLocation() {
      const { form } = this;
      const params = {
        url: window.location.href,
      };
      const wx = window.wx;
      if (!wx) return;
      wechatService.initJsJdk(params).then((res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: ["openLocation", "getLocation"], // 必填，需要使用的 JS 接口列表
        });
      });
      wx.ready(function () {
        console.log("初始化成功");
        wx.getLocation({
          type: "wgs84", // 默认为wgs84的 gps 坐标，如果要返回直接给 openLocation 用的火星坐标，可传入'gcj02'
          success: function (res) {
            form.location_x = res.latitude;
            form.location_y = res.longitude;
          },
        });
      });
      wx.error(function (res) {
        console.log(res);
      });
    },
    getPhoneCode() {
      const { form, countDown } = this;
      if (countDown > 0) {
        return;
      } else if (!phoneReg.test(form.phone)) {
        Message({
          type: "warning",
          message: "请输入正确的手机号",
        });
        return;
      }
      const params = {
        customer_mobile: form.phone,
      };
      sphService.getPhoneCode(params).then(() => {
        Message({
          message: "发送成功",
          type: "success",
        });
        this.countDown = 60;
        clearInterval(timer);
        timer = setInterval(() => {
          this.countDown--;
          if (this.countDown <= 0) {
            clearInterval(timer);
          }
        }, 1000);
      });
    },
    submit() {
      const { form, ifAgree } = this;
      let errMsg = "";
      if (!ifAgree) {
        errMsg = "请先阅读并同意圆和医疗《用户隐私协议》";
      } else if (!form.user_name.trim()) {
        errMsg = "请输入姓名";
      } else if (!form.relation) {
        errMsg = "请选择与患者关系";
      } else if (!phoneReg.test(form.phone)) {
        errMsg = "请填写正确的手机号";
      } else if (!form.code) {
        errMsg = "请填写验证码";
      } else if (!form.bingqingmiaoshu.trim()) {
        errMsg = "请填写病情描述";
      }
      // else if (!form.bingzhong) {
      //   errMsg = "请选择病种";
      // } else if (form.bingzhong === "其他" && !form.other.trim()) {
      //   errMsg = "请填写其他病种";
      // }  else if (form.email && !mailReg.test(form.email)) {
      //   errMsg = "请填写正确的邮箱";
      // }
      if (errMsg) {
        Message({
          type: "warning",
          message: errMsg,
        });
        return;
      }
      const params = {
        ...form,
        bingzhong: form.bingzhong === "其他" ? form.other : form.bingzhong,
        type: this.$route.query.type,
      };
      this.loading = true;
      sphService
        .workAdd(params)
        .then(() => {
          this.loading = false;
          this.$router.replace({
            name: "SphQrcode",
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    protocolClick() {
      if (this.ifAgree) {
        this.ifAgree = 0;
      } else {
        this.ifAgree = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sph-survey {
  background: #eaeaea;
  min-height: 100vh;
  padding-bottom: 20px;
  .van-popup {
    border-radius: 15px;
  }
  .survey-question-code-btn {
    font-size: 14px;
  }
  .survey-form-protocol-lable {
    margin-top: -2px;
  }
}
.sph-survey-header {
  position: relative;
  color: #fff;
  height: 200px;
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
  //   background: linear-gradient(360deg, #e5001e 0%, #002e56 50%, #002e55 100%);
  img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
  }
  .sph-survey-header-content {
    position: absolute;
    z-index: 10;
  }
}
.sph-survey-form {
  margin: 0 20px;
  background-color: #fff;
  padding: 28px 20px 30px 20px;
  border-radius: 20px;
  margin-top: -55px;
  position: relative;
  z-index: 10;
  .survey-form-question {
    margin-bottom: 20px;
    padding-bottom: 7px;
  }
  .survey-form-question-border {
    border-bottom: 1px solid rgba(182, 188, 195, 0.3);
  }
  .van-cell {
    padding: 0;
    padding-bottom: 0;
    font-weight: 300;
    font-size: 16px;
  }
  .survey-question-name {
    font-size: 17px;
    font-weight: 600;
    color: #002d5d;
    margin-bottom: 15px;
  }
  .survey-question-name-require {
    font-weight: 500;
    color: #da0032;
    display: inline-block;
    margin-left: 4px;
  }
  .survey-form-btn {
    .el-button--primary {
      width: 100%;
      background: url("./../../assets/images/sph/confirm_button_bg.png");
      background-size: 100% 100%;
      border: none;
      // padding: 18px 23px;
      height: 50px;
      font-size: 20px;
    }
    margin-top: 30px;
  }
}
</style>
<style lang="scss">
.sph-survey input::-webkit-input-placeholder,
.sph-survey textarea::-webkit-input-placeholder {
  color: #808c9b;
  resize: none;
}
.sph-survey input,
.sph-survey textarea {
  font-weight: 400;
  font-size: 16px;
  color: #002d5d;
}
.sph-survey {
  .el-radio {
    margin: 0;
    display: flex;
    align-items: center;
  }
  .el-radio-group {
    display: flex;
    flex-wrap: wrap;
    .el-radio {
      width: 50%;
    }
  }
  .el-radio {
    font-weight: 100;
    color: #808c9b;
    margin-bottom: 15px !important;
    font-size: 14px;
  }
  .el-radio__inner {
    height: 18px;
    width: 18px;
    border: 1px solid #808c9b;
  }
  .el-radio__inner::after {
    height: 6px;
    width: 6px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #002d5d;
    background: #002d5d;
  }
  .el-radio__label {
    font-size: 16px;
    font-weight: 400;
    line-height: initial;
    margin-top: -2px;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: #002d5d;
  }
  .el-button--info {
    background: #da0032;
    border-color: #da0032;
  }
  .el-input__inner,
  .el-textarea__inner {
    background: rgba(234, 234, 234, 0.5);
    border-radius: 8px 8px 8px 8px;
    border: none;
    resize: none;
  }
  .survey-form-protocol {
    font-size: 14px;
    display: flex;
    align-items: center;
    .el-radio {
      margin-bottom: 0 !important;
    }
    .el-radio__label {
      padding: 0 5px;
    }
    .color-red {
      color: #da0032;
    }
  }
  .el-button--small.is-round {
    padding: 8px 10px;
  }
}
</style>